import { useEffect, useState } from "react";
import ReactPaginate from "react-paginate";

import { formatDate, isDate, useWPAjax } from "../../../../../wp-utils/v1";
import Modal from "../../../../../wp-utils/v1/components/Modal/Modal";
import NewJob from "../NewJob/NewJob";
import JobModal from "./JobModal";

const AllJobs = ({ state, setState, nonce, refetch, isLoading }) => {
  const {
    data: deleteResponse,
    refetch: deleteJobPost,
    isLoading: deleting,
    error: deleteError,
  } = useWPAjax("ajax_request_handler", { method: "delete_job_post", model: "JobPost", nonce }, true);
  const [open, setOpen] = useState(false);
  const [editModalOpen, setEditModalOpen] = useState(false);

  const [itemOffset, setItemOffset] = useState(0);
  const [currentItem, setCurrentItem] = useState({});
  const { auth } = state;

  if (!Array.isArray(state.jobs)) {
    return "invalid Data";
  }

  const itemsPerPage = 10;
  const endOffset = itemOffset + itemsPerPage;
  const currentItems = state.jobs?.slice(itemOffset, endOffset);
  const pageCount = Math.ceil(state?.jobs?.length / itemsPerPage);

  const handlePageClick = (event) => {
    const newOffset = (event.selected * itemsPerPage) % state.jobs?.length;
    setItemOffset(newOffset);
  };

  useEffect(() => {
    if (!deleting && !deleteError) {
      refetch();
    }
  }, [deleting]);

  return (
    <div>
      <div className="text-center mb-2">
        <h3 className="text-3xl">Jobs</h3>
      </div>
      <div className="relative overflow-x-auto shadow-md sm:rounded-lg">
        <table className="w-full text-sm text-left text-gray-500 dark:text-gray-400">
          <thead className="text-xs text-gray-700 uppercase bg-gray-50 dark:bg-gray-700 dark:text-gray-400">
            <tr>
              <th scope="col" className="px-6 py-3 text-center">
                Title
              </th>
              <th scope="col" className="px-6 py-3 text-center">
                Company
              </th>
              <th scope="col" className="px-6 py-3 text-center">
                Qualification
              </th>
              <th scope="col" className="px-6 py-3 text-center">
                Apx. Salary
              </th>
              <th scope="col" className="px-6 py-3 text-center">
                Dead Line
              </th>
              <th scope="col" className="px-6 py-3 text-center">
                Action
              </th>
            </tr>
          </thead>
          <tbody>
            {currentItems?.map((job) => {
              const { title, post, post_author, meta } = job;
              const { company, dead_line, education_qualification, apx_salary } = meta;
              return (
                <tr key={job.id} className="bg-white border-b dark:bg-gray-900 dark:border-gray-700">
                  <th scope="row" className="px-6 py-4 font-medium text-gray-900 whitespace-nowrap dark:text-white">
                    {title}
                  </th>
                  <td className="px-6 py-4">{company}</td>
                  <td className="px-6 py-4">{education_qualification}</td>
                  <td className="px-6 py-4">{apx_salary}</td>
                  <td className="px-6 py-4">{isDate(dead_line) ? formatDate(new Date(dead_line), "DD CMM YYYY") : dead_line}</td>
                  <td className="px-6 py-4">
                    <button
                      onClick={() => {
                        setCurrentItem(job);
                        setOpen(true);
                      }}
                      href="#"
                      disabled={deleting}
                      className="ml-2 border-none font-medium text-white bg-gray-700 px-2 py-1 rounded hover:text-white hover:bg-gray-800 disabled:opacity-50"
                    >
                      View
                    </button>
                    {(["administrator", "admin"].includes(auth?.role) || post?.post_author == auth?.data?.user_id) && (
                      <button
                        disabled={deleting}
                        onClick={() => {
                          const confirm = window.confirm("Are you sure you want to delete?");
                          if (confirm) {
                            deleteJobPost({ id: job.id });
                          }
                        }}
                        href="#"
                        className="ml-2 border-none font-medium text-white bg-red-700 px-2 py-1 rounded hover:text-white hover:bg-red-800 disabled:opacity-50"
                      >
                        Delete
                      </button>
                    )}
                    {post_author == auth?.data?.user_id && (
                      <button
                        disabled={deleting}
                        onClick={() => {
                          setCurrentItem(job);
                          setEditModalOpen(true);
                        }}
                        href="#"
                        className="ml-2 mt-2 border-none font-medium text-white bg-red-700 px-2 py-1 rounded hover:text-white hover:bg-red-800 disabled:opacity-50"
                      >
                        Edit
                      </button>
                    )}
                  </td>
                </tr>
              );
            })}
            {isLoading && !deleteResponse && (
              <tr className="text-center">
                <td colSpan={6}>Loading...</td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
      {state.jobs.length > itemsPerPage && (
        <ReactPaginate
          breakLabel="..."
          nextLabel="Next"
          className="pagination"
          onPageChange={handlePageClick}
          pageRangeDisplayed={5}
          pageCount={pageCount}
          previousLabel="Previous"
          renderOnZeroPageCount={null}
        />
      )}
      <Modal open={editModalOpen} onRequestClose={() => setEditModalOpen(false)}>
        {currentItem && <NewJob job={currentItem} nonce={nonce} state={state} setState={setState} />}
      </Modal>
      <Modal open={open} onRequestClose={() => setOpen(false)}>
        <JobModal job={currentItem} />
      </Modal>
    </div>
  );
};

export default AllJobs;
